<div class="container login">
    <div class="row">
        <div class="col-md-10 offset-md-1">
            <div class="box mt40 mb40 static">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="static-content">
                            <h2 class="tac fs-24">Otomotivin Geleceğine Hoşgeldiniz !<span class="font-normal">Yeni
                                    Nesil "<em>2.El Araç Tedariği Sağlama</em>" Uygulaması</span></h2>
                            <span class="font-normal d-block tac"><b>Örnek Uygulama – Otocars</b><br/><a
                                    href="https://www.otocars.com/" target="_blank">https://www.otocars.com</a></span>
                            <section id="demotalepet">
                                <div class="row">
                                    <div class="col-md-12 tac mt10">
                                        <a href="javascript:;" [routerLink]="['/product-contact/1']"
                                            class="extra-link">Ücretsiz Demo Uygulaması Talep
                                            Et</a>
                                    </div>
                                </div>
                                <div class="row mt10">
                                    <div class="col-md-2 tac align-self-center">
                                        <a class="extra-link" href="javascript:;" *ngIf="page!=0"
                                            (click)="page=page-1">GERİ</a>
                                    </div>
                                    <div class="col-md-8 tac mt10">
                                        <img [src]="imgSrcList[page]" />
                                    </div>
                                    <div class="col-md-2 tac align-self-center">
                                        <a class="extra-link" href="javascript:;" *ngIf="page<(imgSrcList.length-1)"
                                            (click)="page=page+1">İLERİ</a>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
